import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  // listLogs: {},
});

const reportReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.RESULT_GET_LIST_LOGS_CAMPAIGN:
      return state.set("listLogs", action.data || null);
    case types.RESULT_GET_DATA_COUNT_VIEW:
      return state.set("dataCount", action.data || null);
    case types.GET_STATIC_CHAR_RESULT:
      return state.set("statisticChart", action.data || null);

    default:
      return state;
  }
};

export default reportReducer;
